var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LayoutMainPages',[_c('div',{staticClass:"flex"},[_c('div',{class:((!_vm.isMobileDevice ? 'left-side' : '') + " mr-14 w-full xl:mr-0")},[_c('UpdatePassword')],1),_c('SecurityBackground',{staticClass:"xl:hidden"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }